import { render, staticRenderFns } from "./select-box.vue?vue&type=template&id=384181d6&"
import script from "./select-box.vue?vue&type=script&lang=js&"
export * from "./select-box.vue?vue&type=script&lang=js&"
import style0 from "./select-box.vue?vue&type=style&index=0&id=384181d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports